import { createSelector } from 'reselect';
import { getChannelForWidget } from '@wix/wix-vod-shared/dist/src/common/selectors/channels';
import { isVisible as canShowSubscriptionUiSelector } from 'widget/components/overlay-texts/channel/subscribe-button-text';
import { isSubscribedTo } from '@wix/wix-vod-shared/dist/src/common/ui-selectors/channel/pricing';

export const canShowSubscription = createSelector(
  getChannelForWidget,
  channel => canShowSubscriptionUiSelector({ channel }),
);

export const canShowCancelSubscription = createSelector(
  getChannelForWidget,
  channel => isSubscribedTo(channel),
);
